export default "__VITE_ASSET__57161dd3__"